/* eslint-disable import/no-webpack-loader-syntax */
let pdfjsOriginal: typeof import('pdfjs-dist/legacy/build/pdf') | null = null;

export const pdfjs = async () => {
  if (pdfjsOriginal === null) {
    pdfjsOriginal = await import('pdfjs-dist/legacy/build/pdf');
    const worker = await import(
      // @ts-ignore
      'pdfjs-dist/legacy/build/pdf.worker?url'
    );
    pdfjsOriginal.GlobalWorkerOptions.workerSrc = worker.default;
  }
  return pdfjsOriginal;
};
